import { ridSegment } from '@krp/client-runtime'

/** Адреса чтения доставки каталога AQSI (`AqsiDeliveryEndpoints`, C5a), через Gateway. */
const base = (resourceId: string) => `/api/aqsi/v1/resources/${ridSegment(resourceId)}/delivery`

export const AQSI_DELIVERY_URLS = {
  status: (resourceId: string) => `${base(resourceId)}/status`,
  operations: (resourceId: string) => `${base(resourceId)}/operations`,
  reconciliation: (resourceId: string) => `${base(resourceId)}/reconciliation`,
} as const
